import React, { useEffect, useState } from "react";
import { show_proper_words } from "../../../utils/Constant";
import { useParams, useSearchParams } from "react-router-dom";
import TopBar from "./components/TopBar";
import OverViewPage from "./components/OverViewPage";
import CoachesPage from "./Coaches/CoachesPage";
import CompaniesPage from "./Companies/CompaniesPage";
import InsightsPage from "./Insights/InsightsPage";
import { InputAdornment, TextField, useMediaQuery } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Funnel } from "lucide-react";
import GeneralMUIDialog from "../../../components/GeneralMUIDialog/GeneralMUIDialog";
import LeadersPage from "./Leaders/LeadersPage";
import PodcastPage from "./PodcastPage/PodcastPage";
import ProfileDialog from "../../../components/ProfileDialog/ProfileDialog";
import { useIds } from "../../../hook/AdminContext";
import AddEditCoachDialog from "./Coaches/components/AddEditCoachModal";
import { filter_icon, search_blue_icon } from "../../../assets";

const mindsetSourcePageContent = {
  subheading: "Transform your mindset with expert coaching and insights",
  type: "company",
  overViewType: "coach",
  sub_section_heading: "Coaches",
  bar: [
    {
      title: "Overview",
      id: "overview",
      icon: "material-symbols-light:overview-key-outline",
    },
    {
      title: "Companies",
      id: "companies",
      icon: "carbon:location-company",
    },
    {
      title: "Coaches",
      id: "coach",
      icon: "stash:user-avatar-light",
    },
    {
      title: "Insights",
      id: "insights",
      icon: "fluent-mdl2:insights",
    },
  ],
  companyTab: {
    heading: "Mindset Companies",
    check_name: "allow_manage_company",
    profile_tab_heading: "Your Company Profile",
    profile_tab_sub_heading_complete:
      "Your company profile is live and visible to others.",
    profile_tab_sub_heading_incomplete:
      "Your company profile is incomplete. Complete it to go live.",
    edit_button_text: "Edit Company",
    draft_button_text: "Edit Company",
  },
  insights: {
    heading: "Mindset Insights",
  },
};
const traingSourcePageContent = {
  subheading:
    "Empower your growth with expert-led training and actionable insights",
  type: "training_provider",
  overViewType: "training_providers",
  sub_section_heading: "Training Providers",
  bar: [
    {
      title: "Overview",
      id: "overview",
      icon: "material-symbols-light:overview-key-outline",
    },
    {
      title: "Training Providers",
      id: "training_providers",
      icon: "stash:user-avatar-light",
    },
    {
      title: "Insights",
      id: "insights",
      icon: "fluent-mdl2:insights",
    },
  ],
  companyTab: {
    heading: "Training Providers",
    check_name: "allow_manage_training_provider",
    profile_tab_heading: "Your Profile",
    profile_tab_sub_heading_complete:
      "Your profile is published and accessible to learners and partners.",
    profile_tab_sub_heading_incomplete:
      "Your profile setup is incomplete. Complete it to make it visible.",
    edit_button_text: "Manage Profile",
    draft_button_text: "Complete Setup",
  },
  insights: {
    heading: "Training Insights",
  },
};
const hrPageContent = {
  subheading:
    "Empower your workforce with expert-led programs and actionable HR insights",
  type: "hr",
  overViewType: "hr",
  sub_section_heading: "HR",
  bar: [
    {
      title: "Overview",
      id: "overview",
      icon: "material-symbols-light:overview-key-outline",
    },
    {
      title: "HR Providers",
      id: "hr",
      icon: "stash:user-avatar-light",
    },
    {
      title: "Insights",
      id: "insights",
      icon: "fluent-mdl2:insights",
    },
  ],
  companyTab: {
    heading: "HR Providers",
    check_name: "allow_manage_hr_provider",
    profile_tab_heading: "Your HR Provider Profile",
    profile_tab_sub_heading_complete:
      "Your HR provider profile is live and visible to potential partners and companies.",
    profile_tab_sub_heading_incomplete:
      "Your HR providers profile is incomplete. Complete it to showcase your expertise.",
    edit_button_text: "Edit Profile",
    draft_button_text: "Set Up Now",
  },
  insights: {
    heading: "HR Insights",
  },
};

const leaderInIndustryPageContent = {
  subheading:
    "Learn from industry leaders sharing real-world experiences and strategies.",
  type: "leader",
  overViewType: "leader",
  sub_section_heading: "Leaders",
  bar: [
    {
      title: "Overview",
      id: "overview",
      icon: "material-symbols-light:overview-key-outline",
    },
    {
      title: "Leaders",
      id: "leader",
      icon: "stash:user-avatar-light",
    },
    {
      title: "Podcasts",
      id: "podcasts",
      icon: "fluent-mdl2:insights",
    },
    {
      title: "Insights",
      id: "insights",
      icon: "fluent-mdl2:insights",
    },
  ],
  insights: {
    heading: "Insights",
  },
};

export default function FeatureTopBarPage() {
  const params = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const { source_slug, feature_slug } = params;
  const { userInfo } = useIds();
  const isMobile = useMediaQuery("(max-width:600px)");

  const [search, setSearch] = useState("");
  const [searchText, setSearchText] = useState("");
  const [filterModal, setFilterModal] = useState("");

  const [openEditProfileModal, setOpenEditProfileModal] = useState(false);
  const [targetCallBackFunction, setTargetCallBackFunction] = useState(null);

  // coach Add Edit Flow
  const [openCoachDialog, setOpenCoachDialog] = useState(false);
  const [selectedCoach, setSelectedCoach] = useState(null);

  const [cardToOpen, setCardToOpen] = useState(
    searchParams.get("tab") || "overview"
  );
  const [contentData, setContentData] = useState(null);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSearchText(search);
    }, 800);
    return () => clearTimeout(timeoutId);
  }, [search]);

  const handleSetCardToOpen = (id) => {
    setSearchText("");
    setSearch("");
    setCardToOpen(id);
    searchParams.set("tab", id);
    setSearchParams(searchParams);
  };

  const handleEditProfile = (value, callBackFunction = () => { }) => {
    setTargetCallBackFunction(() => callBackFunction);
    setOpenEditProfileModal(value);
  };

  const handleOpenCoachDialog = (value, callBackFunction = () => { }) => {
    setTargetCallBackFunction(() => callBackFunction);
    setOpenCoachDialog(value);
  };

  useEffect(() => {
    if (feature_slug == "training-source") {
      setContentData(traingSourcePageContent);
    } else if (feature_slug == "leaders-in-the-industry") {
      setContentData(leaderInIndustryPageContent);
    } else if (feature_slug == "hr") {
      setContentData(hrPageContent);
    } else {
      setContentData(mindsetSourcePageContent);
    }
    setCardToOpen(searchParams.get("tab") || "overview");
  }, [feature_slug]);

  return (
    <>
      <div className="container-fluid feature-topbar-page">
        <div className="border-bottom d-flex justify-content-between mb-3 mb-md-4 flex-column flex-md-row flex-nowrap">
          <div className="mt-3">
            <h3 className="mb-2">{show_proper_words(feature_slug)}</h3>
            <p className="text-gray mb-4">{contentData?.subheading}</p>
          </div>

          {cardToOpen !== "overview" && (
            <div className="d-flex align-items-center flex-nowrap justify-content-start justify-content-md-end mb-3 mb-md-0">
              <div className="custom-input-design">
                <div className="position-relative">
                  <input
                    className="ps-5"
                    placeholder={"Search..."}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />

                  <img
                    src={search_blue_icon}
                    className="input-start-icon"
                    alt=""
                  />
                </div>
              </div>
              {/* <TextField
                variant="outlined"
                placeholder="Search..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                sx={{
                  width: isMobile ? "100%" : 300,
                  "& .MuiOutlinedInput-root": {
                    height: 38,
                    padding: "0 12px",
                    "& fieldset": {
                      borderColor: "#0000003b",
                    },
                    "&:hover fieldset": {
                      borderColor: "#0000003b",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#0000003b",
                    },
                    "& input": {
                      padding: "0 8px",
                    },
                  },
                  "& .MuiInputAdornment-root": {
                    marginRight: 0,
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ fontSize: 20 }} />
                    </InputAdornment>
                  ),
                }}
              /> */}

              {cardToOpen !== "leader" && (
                <div
                  className="ms-2  custom-filter-design"
                  // style={{
                  //   height: 36,
                  //   width: 36,
                  // }}
                  onClick={() => setFilterModal(true)}
                >
                  <img src={filter_icon} />
                </div>
              )}
            </div>
          )}
        </div>
        <TopBar
          items={contentData?.bar}
          cardToOpen={cardToOpen}
          setCardToOpen={handleSetCardToOpen}
        />

        {cardToOpen == "overview" && (
          <>
            <OverViewPage
              setCardToOpen={setCardToOpen}
              overViewType={contentData?.overViewType || ""}
              companyType={contentData?.type}
              contentData={contentData}
              handleEditProfile={handleEditProfile}
              setSelectedCoach={setSelectedCoach}
              handleOpenCoachDialog={handleOpenCoachDialog}
            />
          </>
        )}

        {(cardToOpen == "companies" ||
          cardToOpen == "training_providers" ||
          cardToOpen == "hr") && (
            <>
              <CompaniesPage
                searchText={searchText}
                filterModal={filterModal}
                companyType={contentData?.type}
                contentData={contentData}
                setFilterModal={setFilterModal}
                handleEditProfile={handleEditProfile}
              />
            </>
          )}
        {cardToOpen == "coach" && (
          <>
            <CoachesPage
              searchText={searchText}
              filterModal={filterModal}
              setFilterModal={setFilterModal}
              companyType={contentData?.type}
              setOpenEditProfileModal={handleEditProfile}
              overViewType={contentData?.overViewType || ""}
              setSelectedCoach={setSelectedCoach}
              handleOpenCoachDialog={handleOpenCoachDialog}
            />
          </>
        )}
        {cardToOpen == "leader" && (
          <>
            <LeadersPage
              searchText={searchText}
              filterModal={filterModal}
              setFilterModal={setFilterModal}
              overViewType={contentData?.overViewType || ""}
            />
          </>
        )}
        {cardToOpen == "insights" && (
          <>
            <InsightsPage
              searchText={searchText}
              filterModal={filterModal}
              cardToOpen={cardToOpen}
              contentData={contentData}
              companyType={contentData?.type}
              setOpenEditProfileModal={handleEditProfile}
              setFilterModal={setFilterModal}
            />
          </>
        )}
        {cardToOpen == "podcasts" && (
          <>
            <PodcastPage
              searchText={searchText}
              filterModal={filterModal}
              cardToOpen={cardToOpen}
              contentData={contentData}
              setFilterModal={setFilterModal}
            />
          </>
        )}
      </div>

      {openEditProfileModal && (
        <ProfileDialog
          openModal={openEditProfileModal}
          setOpenModal={setOpenEditProfileModal}
          userInfo={userInfo}
          isCompanyProfile={true}
          feature_slug={feature_slug}
          companyType={contentData?.type}
          callBackFunction={targetCallBackFunction || (() => { })}
        />
      )}

      {openCoachDialog && (
        <AddEditCoachDialog
          open={openCoachDialog}
          onClose={() => setOpenCoachDialog(false)}
          editData={selectedCoach}
          handleCallBackFunction={targetCallBackFunction}
        />
      )}
    </>
  );
}
